<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <office-table />
      </div>
    </div>
    <!-- <div class="row">
      <div class="col-12">
        <projects-table />
      </div>
    </div> -->
  </div>
</template>

<script>
import OfficeTable from "./components/OfficeTable";
// import ProjectsTable from "./components/ProjectsTable";

export default {
  name: "tables",
  components: {
    OfficeTable,
    // ProjectsTable,
  },
};
</script>
